var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTableArrow = function SvgTableArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    fillRule: "evenodd",
    d: "M20.158 23.544 30.224 13.5l3.092 3.092L20.158 29.75 7 16.592l3.092-3.092z"
  })));
};
export default SvgTableArrow;